import { render, staticRenderFns } from "./FFSegmented.vue?vue&type=template&id=840a61fa&scoped=true&"
import script from "./FFSegmented.vue?vue&type=script&lang=js&"
export * from "./FFSegmented.vue?vue&type=script&lang=js&"
import style0 from "./FFSegmented.vue?vue&type=style&index=0&id=840a61fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840a61fa",
  null
  
)

export default component.exports